/* override functions api.jquery.js */
localStorage.setItem('_load_id', new Date().getTime());
var cartData = "";
function getCartData() {
  jQuery.getJSON('/cart.js', function (cart) {
    cartData = cart;
  });
}
$(function () {
  getCartData();
})
Shopify.onItemAdded = function (line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function (cart) {
  Shopify.cartUpdateInfo(cart, '.cart-items');
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
    var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('#modalAddToCartError .error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
}

Shopify.addItem = function (variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromFormNew = function (form_id, variant_id, callback) {
  const addToCartBtn = document.getElementById('AddToCart');
  const originalButtonHtml = addToCartBtn.innerHTML;
  addToCartBtn.setAttribute('disabled', 'disabled');
  addToCartBtn.innerHTML = `<span class="loader"></span> Adding to Cart ...`;
  let selectedTimeSlotInput = jQuery('#' + form_id).find("input[name='properties[_slot]']:checked");

  //const is_subscription_product = window.app_product_tags.includes('subscription');
  const selectedTimeSlotVariant = selectedTimeSlotInput.data('variant_id');
  const currentVariantId = jQuery('#' + form_id).find('[name=id]').val();
  const selectedSlotVariant = selectedTimeSlotInput.data("variant_id");
  const type = selectedTimeSlotInput.val();
  const selectedTimeSlotInputPrice = selectedTimeSlotInput.data('variant_price');

  let cartItemsToAdd = [];
  let random_id = new Date().getTime();
  let load_id = localStorage.getItem('_load_id');
  var qty = 1;
  var pincode = "";
  if ($('body').hasClass('modal-open')) {
    var app_product_template = $(".add-item-qv .app-pincode").data('template');
    qty = $('#quickViewModal').find("[name='quantity']").val();
    pincode = jQuery('#add-item-qv .app-pincode').val();
  } else {
    var app_product_template = $('body').data('template');
    qty = $('#' + form_id).find("[name='quantity']").val();
    pincode = jQuery('#' + form_id).find('.app-pincode').val();
  }

  var city = "";
  if (app_product_template == 'product.pan-india') {
    city = jQuery('#' + form_id).find('.selected-pan-city').val();
  } else {
    city = jQuery('#' + form_id).find('.selected-city').val();
  }


  let _date = jQuery('#' + form_id).find("input[name='properties[Delivery date]']").val();
  let _time = jQuery('#' + form_id).find("[name='properties[Time]']").val();
  let msg = jQuery('#' + form_id).find("[name='properties[Personalized message]']").val();

  var time_slot = "";
  if (_date) {
    var date_ = _date.replaceAll('/', '-');
  } else {
    var date_ = _date;
  }

  var fixe_product = cartData.items.filter(item => item.properties.Delivery_date == date_ && (item.properties._type == 'fixed' || item.properties._type == '60-90')).map(item => [item.key, item.properties._random_id]);

  if (fixe_product.length > 0) { if (fixe_product[0].length > 1) { random_id = fixe_product[0][1]; } }

  // add slot item
  if (fixe_product.length == 0 && app_product_template != 'product.pan-india' && app_product_template != 'product.subscription') {
    if (type == 'fixed') {
      cartItemsToAdd.push({
        quantity: 1,
        id: selectedTimeSlotVariant,
        properties: {
          '_parent_vid': currentVariantId,
          '_type': type,
          '_city': city.toLowerCase(),
          '_random_id': random_id,
          '_load_id': load_id,
          '_date': date_,
          '_time': _time,
          '_slot_type': type
        }
      });

      time_slot = _time + " [Rs." + selectedTimeSlotInputPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) + "] - Fixed";
    } else if (type == '60-90') {
      var hasExpressSlotInCart = cartData && cartData.items && cartData.items.some(function(item) {
        return item.handle === 'express-delivery';
      });
      if (!hasExpressSlotInCart) {
        cartItemsToAdd.push({
          quantity: 1,
          id: selectedTimeSlotVariant,
          properties: {
            '_parent_vid': currentVariantId,
            '_type': type,
            '_city': city.toLowerCase(),
            '_random_id': random_id,
            '_load_id': load_id,
            '_date': date_,
            '_time': _time,
            '_slot_type': type
          }
        });
      }

      time_slot = _time + " - [Rs." + selectedTimeSlotInputPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) + "]";
    } else if (type == 'standard') {
      time_slot = _time + " - Standard";
    }
  } else {
    time_slot = _time;
  }
  const propertiesToAdd = {
    'City': city,
    '_slot_type': type,
    '_type': 'main',
    '_random_id': random_id,
    '_load_id': load_id,
    '_pincode': pincode,
    '_time': _time,
    //'Selected city': city,
    //'_date': date_,
    'Delivery_date': date_,
    'Time': time_slot,
    'Personalized_message': msg,
    //'_msg': msg
  }
  cartItemsToAdd.push({
    quantity: qty,
    id: currentVariantId,
    properties: propertiesToAdd
  })


  // addon products
  let addonProductTitles = [];
  let addonProductVariantIds = [];
  let customProduct = currentVariantId.toString().substring(5);


  jQuery('#' + form_id + ' [name=app-addons]:checked').each(function () {

    let addon_title = jQuery(this).data('product_title') || ''
    cartItemsToAdd.push({
      quantity: 1,
      id: this.value,
      properties: {
        'Add-on for': app_product_title,
        _custom_product: customProduct,
        _parent_vid: currentVariantId,
        _city: city,
        _date: date_,
        _type: 'addon',
        _random_id: random_id,
        _load_id: load_id,
        _slot_id: selectedTimeSlotVariant
      }
    });
  });

  function addItemsToCart() {
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: { items: cartItemsToAdd },
      beforeSend: function () {
        $('.addtocartqv').attr('disabled', 'disabled');
      },
      success: function (line_item) {
        addToCartBtn.innerHTML = originalButtonHtml;
        $('#AddToCart').removeAttr('disabled', 'disabled');
        getCartData();
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if (form_id != "add-item-qv") {
            if (app_product_template === 'product.inter-city') {
              window.location.href = '/checkout';
            } else if ($('body').hasClass('template-cart')) {
              location.reload();
              return;
            } else {
              Shopify.cartPopapForm(variant_id);
            }
          }

          else {
            $('.addtocartqv').removeAttr("disabled");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function () {
              jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }

      },
      error: function (XMLHttpRequest, textStatus) {
        addToCartBtn.innerHTML = originalButtonHtml;
        addToCartBtn.removeAttribute('disabled');
        if (form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          $('.addtocartqv').removeAttr("disabled");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        }
        // jQuery.getJSON('/cart.js', function(cart) {
        //   if(cart){
        //     Shopify.cartUpdateAdditionalItem(cart);
        //   }
        // });
      }
    });
  }


  if (app_product_template === 'product.inter-city') {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function () {
        addItemsToCart();
      },
      error: function (XMLHttpRequest, textStatus) {
        console.error('Failed to clear cart');
      }
    });

  } else {

    $.getJSON('/cart.js', function (cart) {
      // ── EXPRESS CAP LIMIT CHECK (Max 2 express items per order) ──
      var currentExpressQty = 0;
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._type === 'main' && item.properties._slot_type === '60-90') {
          currentExpressQty += item.quantity;
        }
      });

      var proposedQty = parseInt(qty) || 1;
      var newProposedExpressQty = currentExpressQty;
      if (type === '60-90') {
        newProposedExpressQty += proposedQty;
      }

      if (newProposedExpressQty > 2) {
        // Show validation error using the existing modalAddToCartError
        jQuery('#modalAddToCartError .error_message').text("You can only order a maximum of 2 express delivery products per order.");
        jQuery('#modalAddToCartError').modal("toggle");

        // Restore button state
        addToCartBtn.innerHTML = originalButtonHtml;
        $('#AddToCart').removeAttr('disabled', 'disabled');
        $('.addtocartqv').removeAttr("disabled");
        if (form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }
        return;
      }

      var requests = [];

      cart.items.forEach(function (item) {
        if (
          item.properties &&
          item.properties.City === 'Intercity'
        ) {
          requests.push(
            $.ajax({
              url: '/cart/change.js',
              type: 'POST',
              dataType: 'json',
              data: {
                id: item.key,
                quantity: 0
              }
            })
          );
        }
      });

      if (requests.length === 0) {
        addItemsToCart();
        return;
      }

      $.when.apply($, requests)
        .done(function () {
          console.log('All Intercity items removed');
          addItemsToCart();
        })
        .fail(function (err) {
          console.error('Failed to remove item', err);
        });
    });

  }
}

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function () {
      if (form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        $('.addtocartqv').attr('disabled', 'disabled');
      }
    },
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          $('.addtocartqv').removeAttr("disabled");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function () {
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
        setTimeout(function () {
          jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
      //Shopify.onItemAdded(line_item);
    }
  };
  jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function (form, product_id) {
  //$("#"+form)[0].reset();
  Shopify.addItemFromForm(form, product_id);
}

Shopify.addItemFromFormStartNew = function (form, product_id) {
  Shopify.addItemFromFormNew(form, product_id);
}

Shopify.cartPopap = function (variant_id) {
  var image = jQuery('.' + variant_id + ':first .popup_cart_image').attr("src");
  var title = jQuery('.' + variant_id + ':first .popup_cart_title').text();
  jQuery('.popupimage').attr("src", '' + image + '');
  jQuery('.productmsg').text('' + title + ' added to cart.');
  // jQuery('#modalAddToCart').modal("toggle");
  modalToggle();
}
Shopify.cartPopapForm = function (variant_id) {
  // var image = jQuery('.product_variant_image').attr("src");
  // var title = jQuery('#popup_cart_title').text();
  var price = jQuery('#ProductPrice').text();
  //jQuery('.popupimage').attr("src",''+image+'');
  //jQuery('.productmsg').text(''+title+' added to cart.');
  jQuery('.cart_total_amount').text(price);
  modalToggle();
  tabSlider();
}

function modalToggle() {
  jQuery('#modalAddToCart').modal('toggle');
  jQuery('#modalAddToCart').off('shown.bs.modal').on('shown.bs.modal', function () {
    const $firstTab = $('.addon-cart-popup .type-tab:visible').first();
    if ($firstTab.length) {
      $firstTab.trigger('click');
    }
    tabSlider();
  });

  let currentCardCount = 0;
  const $slider = $('.addon-cart-popup #filtered-products');
  function getSlidesToShow() {
    return window.innerWidth <= 400 ? 2 : 3;
  }

  function destroySlider() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  function initializeSlider() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  const $addontabs = $('.addon-cart-popup .type-tab');
  const $productContainer = $('.addon-cart-popup #filtered-products');

  // Cache all products only once
  if (!$productContainer.data('allProducts')) {
    $productContainer.data(
      'allProducts',
      $productContainer.find('.product-card').clone()
    );
  }

  const $allProducts = $productContainer.data('allProducts');

  // Show/hide tabs based on available products
  $addontabs.each(function () {
    const tabType = $(this).data('type');
    const hasMatchingProduct = $allProducts.toArray().some(function (product) {
      const $product = $(product);
      return tabType === 'all' || $product.data('type') === tabType;
    });

    $(this).toggle(hasMatchingProduct);
  });

  // Remove previous click handlers to avoid duplicates
  $addontabs.off('click').on('click', function () {
    const selectedType = $(this).data('type');
    destroySlider();
    $productContainer.empty();
    const filteredProducts = $allProducts.filter(function () {
      const productType = $(this).data('type');
      return selectedType === 'all' || productType === selectedType;
    });

    $productContainer.append(filteredProducts);
    currentCardCount = filteredProducts.length;
    initializeSlider();
    // $slider.slick('setPosition');

    $addontabs.removeClass('active');
    $(this).addClass('active');
  });

  const $firstTab = $addontabs.filter(':visible').first();
  if ($firstTab.length) {
    $firstTab.trigger('click');
  }

  if ($slider.hasClass('slick-initialized')) {
    // $slider.slick('setPosition');
  }
}

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function (key, value) {
        if (key === 'items') {

          if (value.length) {
            jQuery(".mini-cart").css({ "display": "block" });
            jQuery(".cart-empty-title").css({ "display": "none" });

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              //console.log("item===",item);
              if (item.handle != 'slot-fixe-time' && item.handle != 'express-delivery') {

                if (item.properties._random_id && item.properties._type != 'addon') {
                  jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img alt="" src="' + item.image + '"></a></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><h6>Qty: ' + item.quantity + '</h6><span>' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="shopping-cart-delete"><a class="remove-item"  data-item-key ="' + item.key + '"   data-variant-id="' + item.variant_id + '" data-item-random_id="' + item.properties._random_id + '" href="javascript:void(0);" title="Remove this item"><span>' + jQuery(".cart_messages .delete").text() + '</span><i class="ion ion-close"></i></a></div></li>').appendTo(table);
                } else {
                  jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img alt="" src="' + item.image + '"></a></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><h6>Qty: ' + item.quantity + '</h6><span>' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="shopping-cart-delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" title="Remove this item"><span>' + jQuery(".cart_messages .delete").text() + '</span><i class="ion ion-close"></i></a></div></li>').appendTo(table);
                }
              }
            });
          }
          else {
            jQuery(".mini-cart").css({ "display": "none" });
            jQuery(".cart-empty-title").css({ "display": "block" });
          }
        }
      });
    }
  }
  var main_product = cart.items.filter(function (item0) { return item0.handle == "slot-fixe-time" || item0.handle == "express-delivery" });
  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));

  if (main_product.length > 0) {
    var cart_item_count = cart.item_count - main_product.length;
    changeHtmlValue(".bigcounter", cart_item_count);
  } else {
    changeHtmlValue(".bigcounter", cart.item_count);
  }


  jQuery('.currency .active').trigger('click');
}
Shopify.cartUpdateItem = function (remove_product) {

  var data = { updates: {} };
  if (remove_product.length > 0) {
    for (i = 0; i < remove_product.length; i++) {
      data.updates[remove_product[i]] = 0;
    }
  }
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    beforeSend: function () { },
    success: function success(cart) {

      if ($('body').hasClass('template-cart')) {
        location.reload();
      } else {
        Shopify.onCartUpdate(cart)
      }
    },
    error: function error(data) { if (data.statusText != 'abort') { } },
    complete: function () { }
  });
}

$(document).on('click', '.dec.qtybtn', function () {
  var $input = $(this).closest('.product-quantity').find('input');
  var qty = $input.val();
  var refranceid = $input.data('refranceid');
  var addonQty = 0;

  if (qty == 0) {
    addonQty = 0;
  } else {
    addonQty = 1;
  }

  var count_main = 0;
  $(".cart-from .product-quantity input[name='updates[]']").each(function () {
    if (refranceid == $(this).data('refranceid') && $(this).data('type') == "main") { count_main += 1; }
  });

  if (count_main == 1) {
    $(".cart-from .product-quantity input[name='updates[]']").each(function () {
      if (refranceid == $(this).data('refranceid') && $(this).data('type') == "addon") {
        $(this).val(addonQty);
      } else if (refranceid == $(this).data('refranceid') && $(this).data('type') == "slot") {
        $(this).val(addonQty);
      }
    });
  }

  //var data = {line: $input.data('line'),quantity: $input.val()};
  //console.log('minus',data);

});
$(document).on('click', '.inc.qtybtn', function () {

  var $input = $(this).closest('.product-quantity').find('input');
  var qty = $input.val();
  var refranceid = $input.data('refranceid');
  var addonQty = 0;

  if (qty == 0) {
    addonQty = 0;
  } else {
    addonQty = 1;
  }
  var count_main = 0;
  $(".cart-from .product-quantity input[name='updates[]']").each(function () {
    if (refranceid == $(this).data('refranceid') && $(this).data('type') == "main") { count_main += 1; }
  });

  if (count_main == 1) {
    $(".cart-from .product-quantity input[name='updates[]']").each(function () {
      if (refranceid == $(this).data('refranceid') && $(this).data('type') == "addon") {
        $(this).val(addonQty);
      } else if (refranceid == $(this).data('refranceid') && $(this).data('type') == "slot") {
        $(this).val(addonQty);
      }
    });
  }
});

$(document).on("click", ".cart-from .update-btn", function (e) {
  e.preventDefault();
  var data = { updates: {} };
  
  $.getJSON('/cart.js', function (cart) {
    var proposedExpressQty = 0;
    var expressSlotKeys = [];
    
    $(".cart-from .product-quantity input[name='updates[]']").each(function () {
      var quantity = parseInt($(this).val()) || 0;
      var key = $(this).data('line');
      var type = $(this).data('type');
      var handle = $(this).data('handle');
      
      data.updates[key] = quantity;
      
      if (type === 'main') {
        var cartItem = cart.items.find(item => item.key === key);
        if (cartItem && cartItem.properties && cartItem.properties._slot_type === '60-90') {
          proposedExpressQty += quantity;
        }
      }
      if (handle === 'express-delivery') {
        expressSlotKeys.push(key);
      }
    });
    
    if (proposedExpressQty > 2) {
      alert("You can only order a maximum of 2 express delivery products per order.");
      return;
    }
    
    // Adjust express slot item updates so express charge is added only once per order
    if (expressSlotKeys.length > 0) {
      var targetExpressQty = proposedExpressQty > 0 ? 1 : 0;
      for (var i = 0; i < expressSlotKeys.length; i++) {
        data.updates[expressSlotKeys[i]] = (i === 0) ? targetExpressQty : 0;
      }
    }
    
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      beforeSend: function () { },
      success: function success(data) {
        location.reload();
      },
      error: function error(data) { if (data.statusText != 'abort') { } },
      complete: function () { }
    });
  });
});

$(document).on('click', '.remove-item', function () {
  var rendom_id = $(this).data('item-random_id');
  var variantid = $(this).data('variant-id');
  var key = $(this).data('item-key');
  //console.log('key',key);
  //console.log('rendom_id',rendom_id);
  //console.log('variantid',variantid);
  jQuery.getJSON('/cart.js', function (cart) {
    if (cart) {
      var data = { updates: {} };
      var remove_product;
      if (rendom_id != '') {
        remove_product_1 = cart.items.filter(item => item.properties._random_id == rendom_id).map(item => item.key);
        remove_product_main = cart.items.filter(item => item.properties._random_id == rendom_id && item.properties._type == 'main').map(item => [item.key, item.properties._type]);
        if (remove_product_main.length > 1) {
          remove_product = cart.items.filter(item => item.key == key).map(item => item.key);
        } else {
          remove_product = remove_product_1;
        }
      } else {
        remove_product = cart.items.filter(item => item.variant_id == variantid).map(item => [item.key, item.properties._type]);
      }
      if (remove_product.length > 0) {
        // Prevent removal of express-delivery charge if another express main product remains
        var remainingExpressMain = cart.items.filter(function(item) {
          var isExpressMain = item.properties && item.properties._type === 'main' && item.properties._slot_type === '60-90';
          var isBeingRemoved = remove_product.some(function(val) {
            return Array.isArray(val) ? val[0] === item.key : val === item.key;
          });
          return isExpressMain && !isBeingRemoved;
        });

        if (remainingExpressMain.length > 0) {
          remove_product = remove_product.filter(function(val) {
            var itemKey = Array.isArray(val) ? val[0] : val;
            var item = cart.items.find(i => i.key === itemKey);
            return !item || item.handle !== 'express-delivery';
          });
        }
      }
      if (remove_product.length > 0) { Shopify.cartUpdateItem(remove_product); }
    }
  });
});

function getval() {
  var currentTime = new Date()
  var hours = currentTime.getHours()
  var minutes = currentTime.getMinutes()

  if (minutes < 10) minutes = "0" + minutes;

  var suffix = "AM";
  if (hours >= 12) {
    suffix = "PM";
    hours = hours - 12;
  }
  if (hours == 0) {
    hours = 12;
  }
  var current_time = hours + ":" + minutes + " " + suffix;

  return current_time;

}
function get24Hr(time) {
  if (!time) return 0;
  var timeRegex = /(\d+)(?::(\d+))?\s*(AM|PM)/i;
  var match = time.match(timeRegex);
  if (!match) return 0;
  
  var hours = Number(match[1]);
  var minutes = match[2] ? Number(match[2]) : 0;
  var AMPM = match[3].toUpperCase();
  
  if (AMPM == "PM" && hours < 12) hours = hours + 12;
  if (AMPM == "AM" && hours == 12) hours = hours - 12;

  hours = hours * 100 + minutes;
  return hours;
}

Shopify.cartUpdateAdditionalItem = function (cart) {
  var currentDate = new Date();
  var currentHour = currentDate.getHours();
  var currentDateOnly = (new Date()).toISOString().split('T')[0];

  var item_count = cart.item_count;
  var slot_product = cart.items.filter(function (item0) { return item0.handle == "slot-fixe-time" || item0.handle == "express-delivery" });
  var main_product = cart.items.filter(function (item0) {
    return item0.handle != "slot-fixe-time" && item0.handle != "express-delivery" && item0.properties._type != "addon"
  });
  //console.log('main_product',main_product);

  var rendom_ids = [];
  var rendom_expair_ids = [];
  for (j = 0; j <= main_product.length; j++) {
    if (main_product[j] && main_product[j].properties._random_id) {
      rendom_ids.push(main_product[j].properties._random_id);
    }
    if (main_product[j] && main_product[j].properties.Delivery_date) {
      var itemDate = new Date(main_product[j].properties.Delivery_date).toISOString().split('T')[0];
      var itemTime = main_product[j].properties._time.replaceAll('.', ":");
      var timeSlotRange = itemTime.split("to");
      var startTime = $.trim(timeSlotRange[0]);
      var endTime = $.trim(timeSlotRange[1]);
      var curr_time = getval();

      //console.log('itemDate',itemDate);
      //console.log('currentDateOnly',currentDateOnly);

      if (currentDateOnly > itemDate) {
        rendom_expair_ids.push(main_product[j].properties._random_id);
        //console.log('temp1');
      }
      //console.log(currentDate , itemDate)
      //if (currentDateOnly == itemDate && get24Hr(curr_time) > get24Hr(startTime) && get24Hr(curr_time) < get24Hr(endTime)) {
      if (currentDateOnly == itemDate && get24Hr(curr_time) > get24Hr(startTime) && get24Hr(curr_time) < get24Hr(endTime)) {
        //console.log('tes1',main_product[j].properties._random_id);
        //console.log('temp1');
      } else {
        rendom_expair_ids.push(main_product[j].properties._random_id);
        //console.log('tes2',main_product[j].properties._random_id);
        //console.log('temp2');
        //rendom_expair_ids.push(main_product[j].properties._random_id);
        //console.log('main_product[j].properties._random_id',main_product[j].properties._random_id);
      }

    }
  }
  rendom_expair_ids = rendom_expair_ids.filter((x, i, a) => a.indexOf(x) == i)

  //console.log('rendom_expair_ids',rendom_expair_ids);

  var data = { updates: {} };
  for (i = 0; i <= cart.item_count; i++) {
    if (cart.items[i] && cart.items[i].properties._random_id) {
      if (rendom_ids.includes(cart.items[i].properties._random_id) == false) {
        data.updates[cart.items[i].key] = 0;
      }
      if (jQuery.inArray(cart.items[i].properties._random_id, rendom_expair_ids) != -1) {
        data.updates[cart.items[i].key] = 0;
      }
    }
  }
  //console.log('cartUpdateAdditionalItem',data);

  if (!$.isEmptyObject(data.updates)) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      beforeSend: function () { },
      success: function success(data) {
        return true;
      },
      error: function error(data) {
        if (data.statusText != 'abort') {
          return false;
        }
      },
      complete: function () {
        return true;
      }
    });
  } else {
    return true;
  }
}
//Utils


function checkCartItem(url, cart) {
  return new Promise((resolve) => {
    //console.log('randomIds--2',randomIds.split(","));
    var currentDate = new Date();
    var currentHour = currentDate.getHours();
    var currentDateOnly = (new Date()).toISOString().split('T')[0];
    var item_count = cart.item_count;
    var slot_product = cart.items.filter(function (item0) { return item0.handle == "slot-fixe-time" || item0.handle == "express-delivery" });
    var main_product = cart.items.filter(function (item0) { return item0.handle != "slot-fixe-time" && item0.handle != "express-delivery" && item0.properties._type != "addon" });

    var rendom_ids = [];
    var rendom_expair_ids = [];
    
    if (typeof randomIds !== 'undefined') {
      rendom_expair_ids = randomIds.split(",");
    } else {
      for (var j = 0; j < main_product.length; j++) {
        if (main_product[j] && main_product[j].properties._random_id) {
          rendom_ids.push(main_product[j].properties._random_id);
        }
        if (main_product[j] && main_product[j].properties.Delivery_date) {
          var itemDate = new Date(main_product[j].properties.Delivery_date).toISOString().split('T')[0];
          var itemTime = main_product[j].properties._time ? main_product[j].properties._time.replaceAll('.', ":") : "";
          if (itemTime) {
            var timeSlotRange = itemTime.split(/to/i);
            var startTime = $.trim(timeSlotRange[0]);
            var endTime = timeSlotRange.length > 1 ? $.trim(timeSlotRange[1]) : "";
            var curr_time = getval();

            if (currentDateOnly > itemDate) {
              rendom_expair_ids.push(main_product[j].properties._random_id);
            } else if (currentDateOnly == itemDate) {
              var start24 = get24Hr(startTime);
              var end24 = get24Hr(endTime);
              var curr24 = get24Hr(curr_time);
              
              if (end24 > 0) {
                if (curr24 > end24) {
                  rendom_expair_ids.push(main_product[j].properties._random_id);
                }
              } else if (start24 > 0) {
                if (curr24 > start24) {
                  rendom_expair_ids.push(main_product[j].properties._random_id);
                }
              }
            }
          } else {
            if (currentDateOnly > itemDate) {
              rendom_expair_ids.push(main_product[j].properties._random_id);
            }
          }
        }
      }
    }
    
    rendom_expair_ids = rendom_expair_ids.filter((x, i, a) => a.indexOf(x) == i);

    //console.log('rendom_expair_ids',rendom_expair_ids);

    var data = { updates: {} };
    for (i = 0; i <= cart.item_count; i++) {
      if (cart.items[i] && cart.items[i].properties._random_id) {
        // if(rendom_ids.includes(cart.items[i].properties._random_id) == false ){ 
        //   data.updates[cart.items[i].key] = 0;
        // }
        if (jQuery.inArray(cart.items[i].properties._random_id, rendom_expair_ids) != -1) {
          data.updates[cart.items[i].key] = 0;
        }
      }
    }
    //console.log('data-remove',data);
    if (!$.isEmptyObject(data.updates)) {
      if (typeof swal !== 'undefined') {
        swal({
          //title: 'Are you sure?',
          html: "<b>Expired Date/Time Slot Items in Cart </b></br><br>We detected some items with expired time slots or dates in your cart. Would you like to edit your cart or proceed to checkout? <br>If you click <b>Proceed to Checkout</b>, expired items will be automatically removed.",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Proceed to Checkout',
          cancelButtonText: 'Edit Cart'
        }).then((willDelete) => {
          if (willDelete.value) {
            $.ajax({
              url: url,
              data: data,
              type: "POST",
              dataType: "json",
              success: function (line_item) {
                document.location.href = '/cart/checkout';
              }
            });
          } else {
            if(window.location.pathname !== '/cart') {
              window.location.href = '/cart';
            }
            return false;
          }
        });
      } else {
        var proceed = confirm("Expired Date/Time Slot Items in Cart\n\nWe detected some items with expired time slots or dates in your cart. Would you like to edit your cart or proceed to checkout? \nIf you click OK, expired items will be automatically removed.");
        if (proceed) {
          $.ajax({
            url: url,
            data: data,
            type: "POST",
            dataType: "json",
            success: function (line_item) {
              document.location.href = '/cart/checkout';
            }
          });
        } else {
          if(window.location.pathname !== '/cart') {
            window.location.href = '/cart';
          }
        }
      }
    } else {
      document.location.href = '/cart/checkout';
    }
  });
}

async function asyncCall() {
  //console.log('calling');
  var result = await checkCartItem('/cart/update.js', cartData);
  // console.log("result",result);
}

$(document).on('click', '#checkout', function (e) {
  e.preventDefault();
  asyncCall();
  // if(result){
  //   document.location.href = '/cart/checkout';
  // }
});


function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}